// extracted by mini-css-extract-plugin
export default {"root":"root--KDUFs","message":"message--_cNCu","button":"button--JqhbB"};